import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';

import { routes } from './routes';
import { FlightBooking } from './flights/booking';
import { FlightPayment } from './flights/payment';
import { FlightVoucher } from './flights/voucher';
import { Hotels } from './hotels/home';
import { Cars } from './cars/home';
import { Explorer } from './explorer/home';
import { Layout } from '@frontend/features/common/components/Layout';
import { FlightsAvailability } from './flights/availability';
import { Sublayout } from '../features/common/components/Sublayout';
import { HotelSuppliersView, DefaultSuppliersView, VendorHotelsView, BoardsView, CategoriesView, DestinationsView, NimbuxHotelsList } from './hotel-content';
import { Error404 } from './404';
import { Error401 } from './401';
import { ProtectedRoute } from '@frontend/features/auth/components/ProtectedRoute';
import { DashboardLayout } from '@frontend/features/dashboard/components/DashboardLayout';
import { ClientsList } from './clients/list';
import { WorkflowsList } from './agencies/workflows-list';
import { Dashboard } from './dashboard';
import { AgencyList } from './agencies/list';
import { ClientView } from './clients/view';
import { TeamsList } from './agencies/teams-list';
import { CasesList } from './cases/list';
import { CaseView } from './cases/view';
import WorkflowView from './agencies/workflows-view';
import { AgencyView } from './agencies/view';
import { UsersList } from './users/list';
import { TeamView } from './agencies/teams-view';
import { UserView } from './users/view';
import { GeneralSettings } from './agencies/general-settings';
import { MarkupRulesList } from './agencies/markup-rules-list';
import { MarkupRulesEdit } from './agencies/markup-rules-view';
import { AirRoutingRules } from './agencies/air-routing-rules-list';
import { SuportFormList } from './agencies/support-form-list';
import { SupportFormEdit } from './agencies/support-form-edit';
import { ExternalSupportForm } from './support/view';
import { HotelsAvailability } from './hotels/availability';
import { OrganizationsList } from './agencies/organization-list';
import { OrganizationView } from './agencies/organization-view';
import { HotelFares } from './hotels/fares';
import { CustomFields } from './agencies/custom-fields-list';
import { CustomFieldsView } from './agencies/custom-fields-view';
import { Cart } from './saleorder/cart';
import { SaleOrderList } from './saleorder/list';
import { SaleOrderView } from './saleorder/view';
import { SaleOrderItem } from '@frontend/features/sale-orders/components/item';
import { SaleOrderPaxes } from '@frontend/features/sale-orders/components/paxes';
import { Home } from './home';
import { CommunicationSettings } from './agencies/communications-view';
import CallsMenu from './agencies/callsMenu';
import { InvalidationRulesList } from '@frontend/router/agencies/invalidation-rules-list';
import { InvalidationRulesView } from '@frontend/router/agencies/invalidation-rules-view';
import { WhatsappList } from './whatsapp/list';
import { WhatsappSettingsView } from './agencies/whatsapp-view';
import { IaConfigView } from './agencies/ia-config-view';
import { CallsList } from './calls/list';
import { DataUploadsView } from './agencies/data-uploads';
import { IaCaseEventHandlersList } from './agencies/case-handlers-list';
import { FlightIntegrationsList } from "@frontend/router/flight-integrations/list";
import { AgencyFlightIntegrationsList } from "@frontend/router/agencies/agency-flight-integrations-list";
import { HotelIntegrationsList } from "@frontend/router/hotel-integrations/list";
import { HotelContentView } from "./hotel-content";
import { HotelContentViewPage } from './hotel-content-view';
import { NimbuxHotelImageManager } from './hotel-content-view/hotel-image-manager';
import { HotelContentViewGeneral } from './hotel-content-view/general';
import { HotelContentCheckinCheckout } from './hotel-content-view/hotel-checkin-checkout';
import { HotelContentLocation } from './hotel-content-view/hotel-content-location';
import { HotelContentPerse } from './hotel-content-view/hotel-content-perse';
import { HotelContentAmenities } from './hotel-content-view/hotel-content-amenities';
import { HotelPropertyFares } from './hotel-property-fares';
import { CaseTriggersList } from './agencies/case-triggers';
import { WebhooksList } from './agencies/webhooks-list';
import { MetaCapiSettingsView } from './agencies/meta-capi-settings';
import { CopilotView } from './agencies/copilot-view';
import { AgencyKnowledgeView } from './agencies/agency-knowledge-view';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path={routes.error404} element={<Error404 />} />
      <Route path={routes.error401} element={<Error401 />} />
      <Route path="/" element={<Layout />}>
        <Route element={<Sublayout noPayments noFooter />}>
          <Route path={routes.home} element={<Home />} />
          <Route
            path={routes.hotels.home}
            element={
              <ProtectedRoute action="view" path="Hotels">
                <Hotels />
              </ProtectedRoute>
            }
          />
          <Route
            path={routes.cars}
            element={
              <ProtectedRoute action="view" path="Cars">
                <Cars />
              </ProtectedRoute>
            }
          />
          <Route
            path={routes.explorer}
            element={
              <ProtectedRoute action="view" path="Explorer">
                <Explorer />
              </ProtectedRoute>
            }
          />
          <Route
            path={routes.salesorder.cart}
            element={
              <ProtectedRoute action="view" path="Cart">
                <Cart />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          path={routes.dashboard.index}
          element={
            <ProtectedRoute action="view" path="Dashboard">
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route element={<Sublayout noPayments noFooter isBackOffice />}>
            <Route index element={<Dashboard />} />

            <Route
              path={routes.dashboard.users}
              element={
                <ProtectedRoute action="manage" path="Users">
                  <UsersList />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.dashboard.whatsapp}
              element={
                <ProtectedRoute action="view" path="Calls">
                  <WhatsappList />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.dashboard.calls}
              element={
                <ProtectedRoute action="view" path="Calls">
                  <CallsList />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.dashboard.userView}
              element={
                <ProtectedRoute action="view" path="Users">
                  <UserView />
                </ProtectedRoute>
              }
            />

            <Route
              path={routes.dashboard.clients}
              element={
                <ProtectedRoute action="manage" path="Clients">
                  <ClientsList />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.dashboard.clientView}
              element={
                <ProtectedRoute action="manage" path="Clients">
                  <ClientView />
                </ProtectedRoute>
              }
            />

            <Route
              path={routes.dashboard.cases}
              element={
                <ProtectedRoute action="manage" path="Cases">
                  <CasesList />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.dashboard.caseView}
              element={
                <ProtectedRoute action="manage" path="Cases">
                  <CaseView />
                </ProtectedRoute>
              }
            />

            <Route
              path={routes.dashboard.saleOrder.root}
              element={
                <ProtectedRoute action="manage" path="SaleOrders">
                  <SaleOrderList />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.dashboard.saleOrder.detail}
              element={
                <ProtectedRoute action="manage" path="SaleOrders">
                  <SaleOrderView />
                </ProtectedRoute>
              }
            >
              <Route index element={<SaleOrderPaxes />} />
              <Route path={routes.dashboard.saleOrder.item} element={<SaleOrderItem />} />
              <Route path={routes.dashboard.saleOrder.passengers} element={<SaleOrderPaxes />} />
            </Route>

            <Route
              path={routes.dashboard.flightIntegrations.list}
              element={
                <ProtectedRoute action="manage" path="FlightIntegrations">
                  <FlightIntegrationsList />
                </ProtectedRoute>
              }
            />

            <Route
              path={routes.dashboard.hotelIntegrations.list}
              element={
                <ProtectedRoute action="manage" path="HotelIntegrations">
                  <HotelIntegrationsList />
                </ProtectedRoute>
              }
            />

            <Route
              path={routes.dashboard.hotelContentManagement.root}
              element={
                <ProtectedRoute action="view" path="ContentManager">
                  <HotelContentView />
                </ProtectedRoute>
              }
            >
              <Route index element={<NimbuxHotelsList />} />
              <Route path={routes.dashboard.hotelContentManagement.suppliers} element={<HotelSuppliersView />} />
              <Route path={routes.dashboard.hotelContentManagement.defaultSuppliers} element={<DefaultSuppliersView />} />
              <Route path={routes.dashboard.hotelContentManagement.vendorHotels} element={<VendorHotelsView />} />
              <Route path={routes.dashboard.hotelContentManagement.boards} element={<BoardsView />} />
              <Route path={routes.dashboard.hotelContentManagement.categories} element={<CategoriesView />} />
              <Route path={routes.dashboard.hotelContentManagement.destinations} element={<DestinationsView />} />
            </Route>

            <Route
              path={routes.dashboard.hotelContentView.root}
              element={
                <ProtectedRoute action="view" path="ContentManager">
                  <HotelContentViewPage />
                </ProtectedRoute>
              }
            >
              <Route index element={<HotelContentViewGeneral />} />
              <Route path={routes.dashboard.hotelContentView.checkin} element={<HotelContentCheckinCheckout />} />
              <Route path={routes.dashboard.hotelContentView.location} element={<HotelContentLocation />} />
              <Route path={routes.dashboard.hotelContentView.images} element={<NimbuxHotelImageManager />} />
              <Route path={routes.dashboard.hotelContentView.amenities} element={<HotelContentAmenities />} />
              <Route path={routes.dashboard.hotelContentView.content} element={<HotelContentPerse />} />
            </Route>

            <Route
              path={routes.dashboard.agencies}
              element={
                <ProtectedRoute action="manage" path="Agencies">
                  <AgencyList />
                </ProtectedRoute>
              }
            />
            <Route
              path={routes.dashboard.agencyView.root}
              element={
                <ProtectedRoute action="manage" path="Agencies">
                  <AgencyView />
                </ProtectedRoute>
              }
            >
              <Route index element={<GeneralSettings />} />
              <Route path={routes.dashboard.agencyView.settings} element={<GeneralSettings />} />
              <Route path={routes.dashboard.agencyView.organizations} element={<OrganizationsList />} />
              <Route path={routes.dashboard.agencyView.organization} element={<OrganizationView />} />
              <Route path={routes.dashboard.agencyView.workflows} element={<WorkflowsList />} />
              <Route path={routes.dashboard.agencyView.workflow} element={<WorkflowView />} />
              <Route path={routes.dashboard.agencyView.teams} element={<TeamsList />} />
              <Route path={routes.dashboard.agencyView.communications} element={<CommunicationSettings />} />
              <Route path={routes.dashboard.agencyView.iaCaseEventHandlers} element={<IaCaseEventHandlersList />} />
              <Route path={routes.dashboard.agencyView.caseTriggers} element={<CaseTriggersList />} />
              <Route path={routes.dashboard.agencyView.callsMenu} element={<CallsMenu />} />
              <Route path={routes.dashboard.agencyView.team} element={<TeamView />} />
              <Route path={routes.dashboard.agencyView.markupRulesList} element={<MarkupRulesList />} />
              <Route path={routes.dashboard.agencyView.markupRulesView} element={<MarkupRulesEdit />} />
              <Route path={routes.dashboard.agencyView.airRoutingRules} element={<AirRoutingRules />} />
              <Route path={routes.dashboard.agencyView.supportForm} element={<SuportFormList />} />
              <Route path={routes.dashboard.agencyView.supportFormEdit} element={<SupportFormEdit />} />
              <Route path={routes.dashboard.agencyView.customFields} element={<CustomFields />} />
              <Route path={routes.dashboard.agencyView.customFieldsView} element={<CustomFieldsView />} />
              <Route path={routes.dashboard.agencyView.invalidationRules} element={<InvalidationRulesList />} />
              <Route path={routes.dashboard.agencyView.invalidationRule} element={<InvalidationRulesView />} />
              <Route path={routes.dashboard.agencyView.iaConfig} element={<IaConfigView />} />
              <Route path={routes.dashboard.agencyView.whatsappSettings} element={<WhatsappSettingsView />} />
              <Route path={routes.dashboard.agencyView.uploads} element={<DataUploadsView />} />
              <Route path={routes.dashboard.agencyView.agencyFlightIntegrations} element={<AgencyFlightIntegrationsList />} />
              <Route path={routes.dashboard.agencyView.webhooks} element={<WebhooksList />} />
              <Route path={routes.dashboard.agencyView.metaCapi} element={<MetaCapiSettingsView />} />
              <Route path={routes.dashboard.agencyView.copilot} element={<CopilotView />} />
              <Route path={routes.dashboard.agencyView.agencyKnowledge} element={<AgencyKnowledgeView />} />
            </Route>
          </Route>
        </Route>
      </Route>
      <Route
        path="/"
        element={
          <ProtectedRoute action="view" path="Hotels">
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route element={<Sublayout noPayments noFooter />}>
          <Route path={routes.hotels.availability} element={<HotelsAvailability />} />
        </Route>
        <Route element={<Sublayout noPayments noFooter />}>
          <Route path={routes.hotels.fares} element={<HotelFares />} />
        </Route>
        
        <Route element={<Sublayout noPayments noFooter />}>
          <Route path={routes.hotelPropertyFares} element={<HotelPropertyFares />} />
        </Route>
      </Route>



      <Route path={routes.external.caseSupportForms} element={<ExternalSupportForm />} />

      <Route path={routes.flights.booking} element={<FlightBooking />} />
      <Route path={routes.flights.payment} element={<FlightPayment />} />
      <Route path={routes.flights.voucher} element={<FlightVoucher />} />
      <Route path="/" element={<Layout />}>
        <Route element={<Sublayout noPayments noLargeDownMt noFooter />}>
          <Route path={routes.flightsAvailability} element={<FlightsAvailability />} />
        </Route>
      </Route>
    </Route>,
  ),
);
